// @flow

import React from "react";
import { localize } from "redux-i18n";
import { GSGrid } from "@components";
import { formatDateTime } from "@transformers/date";
import type { DeclinedReferralHistoryRecord } from "@modules/employee/reducer/employee/types";

type OwnProps = $Exact<{
  data: Array<Object>,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class DeclinedReferralHistoryGrid extends React.Component<Props> {
  get columnDefs() {
    return [
      {
        name: this.props.t("REFERRAL_ID"),
        key: "referralId",
        frozen: "left",
      },
      {
        name: this.props.t("REFERRAL_TYPE"),
        key: "referralType",

        renderCell: ({ row }: { row: DeclinedReferralHistoryRecord }) =>
          this.props.t(row.referralType),
      },
      {
        name: this.props.t("DATE_TRIGGERED"),
        key: "dateReferred",
        minWidth: 150,

        renderCell: ({ row }: { row: DeclinedReferralHistoryRecord }) =>
          formatDateTime(row.dateReferred),
      },
      {
        name: this.props.t("REASON_FOR_RECOMMENDED_REFERRAL"),
        key: "reason",
        minWidth: 300,
      },
      {
        name: this.props.t("DECLINED_BY"),

        renderCell: ({ row }: { row: DeclinedReferralHistoryRecord }) => {
          let name = "";
          name += row.completedByFirstName ? `${row.completedByFirstName} ` : "";
          name += row.completedByLastName ? `${row.completedByLastName}` : "";
          return name;
        },
      },
      {
        name: this.props.t("REASON_DECLINED"),
        key: "reasonDeclined",
      },
      {
        name: this.props.t("DATE_DECLINED"),
        key: "dateDeclined",

        renderCell: ({ row }: { row: DeclinedReferralHistoryRecord }) =>
          formatDateTime(row.dateDeclined),
      },
    ];
  }

  get rowData() {
    return this.props.data || [];
  }

  render() {
    return <GSGrid columns={this.columnDefs} rows={this.rowData} />;
  }
}

export default localize()(DeclinedReferralHistoryGrid);
